package ir.yusefpasha.models

enum class Experience(
    val number: String,
    val title: String,
    val subtitle: String,
    val from: String,
    val to: String,
    val description: String
) {

    First(
        number = "01",
        title = "Kotlin Multi-Platform Developer",
        subtitle = "Learning",
        description = """
            Considering the progress and changes in this field, continuous learning is the main way to reach a specific goal that exists in our minds.
            I'm trying to learn KMP and develop different projects as I start learning Compose...
        """.trimIndent(),
        from = "August 2022",
        to = "Now"
    ),

    Second(
        number = "02",
        title = "Ktor + Backend Developer",
        subtitle = "Learning",
        description = """
            To learn the server, I first went to JS (Node + Express) and gained a little experience in this language, but when I started KTOR, I didn't need to learn another syntax, which made me put more effort into learning it as much as possible.
            So far, I have done some Personal and Business Projects with that and in A Word, Working with this Framework is a pleasure...
        """.trimIndent(),
        from = "October 2021",
        to = "Now"
    ),

    Third(
        number = "03",
        title = "Android Developer",
        subtitle = "Learning",
        description = """
            I started Android Development with a small project and with more effort, I became more interested in it, and this interest made me gain nearly three years of experience in this field.
            During this period, I did many experimental, personal and commercial projects, but none of them were commercially and large-scale public in the markets...
        """.trimIndent(),
        from = "January 2020",
        to = "Now"
    ),
}